export const SET_PAGE = 'set_page'
export const SET_PAGE_LIMIT = 'set_page_limit'
export const SET_SORT_BY = 'set_sort_by'
export const SET_PAGE_COUNT = 'set_page_count'
export const SET_LIST_ID = 'set_list_id'
